import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenuComponent } from '../../menu/menu.component';

@Component({
  selector: 'app-main',
  imports: [CommonModule, RouterOutlet, MenuComponent],
  templateUrl: './main.component.html',
  styleUrl: './main.component.less',
})
export class MainComponent {}
